import {
    FETCH_DELETE_UNIVERSITIES_REQUEST,
    FETCH_DELETE_UNIVERSITIES_SUCCESS,
    FETCH_DELETE_UNIVERSITIES_FAILURE,
} from '../../actions/universities/delete-university-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteUniversityReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_UNIVERSITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_UNIVERSITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_UNIVERSITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteUniversityReducer;